<template>
	<div class="container-fluid">
		<navigation-admin></navigation-admin>
		<div class="row row-fluid wrapper-flexbox">
			<sidebar-admin></sidebar-admin>
			<section class="col-sm-10 admin-background-shadow overflow">
				<div class="row no-padding-bottom">
					<div class="col-sm-2">
						<p class="admin-header">Productos</p>
					</div>
					<div class="col-sm-2 col-sm-offset-8">
						<a v-link="{ path: '/admin/products/create'}"type="button" class="btn btn-black btn-lg">Nuevo producto</a>
					</div>
				</div>
				<div class="row no-padding-top">
					<div class="col-sm-6">
					    <input type="text" class="admin-input" placeholder="Buscar producto" v-model="query">
					    
					</div>
				</div>
				<div class="row row-fluid absolute">
					<div class="col-sm-12">
						<table-admin-prod :list="render_products" :url="url" :remove="remove" :query="query"></table-admin-prod>
						<div v-if="!render_products.length" class="text-center empty">No hay productos en la plataforma.</div>
					</div>
				</div>
			</section>
		</div>
	</div>
</template>

<style scoped>
	.input-group .form-control{
		font-family: "Open Sans";
		font-size: 12px;
	}
	.input-group{
		margin-left: 25px;
	}
	.btn-blue{
		padding: 5px 12px;
	}
</style>

<script>
import navigationAdmin from '../../components/Admin/Admin-navigation.vue';
import sidebarAdmin from '../../components/Admin/Admin-sidebar.vue';
import tableAdminProd from '../../components/Admin/Admin-table-prod.vue';
import { confirm } from '../../scripts/confirm';
import { removeProduct } from '../../store/actions';

export default {
	// ------ DATA ------

	data() {
		return {
			url: '/admin/products/edit/',
			query: ''
		}
	},

	// ------ VUEX ------

	vuex: {
		getters: {
			current_user: state => state.current_user,
			products: state => state.products
		},
		actions: {
			removeProduct
		}
	},

	// ------ RENDER ------

	computed: {
		render_products() {
			return this.products;
		}
	},

	// ------ METHODS ------

	methods: {
		remove(product) {
			const vm = this;

			confirm({
				title: 'Eliminar Producto',
				content: 'Seguro que quieres eliminar ' + product.name,
				
				confirm: function () {
					// Send the admin to access to remove products.
					vm.removeProduct(vm.current_user, product);
				},
				
				cancel: function () {
					
				}
			});
		}
	},

	// ------ COMPONENTS ------

  components: {
    navigationAdmin,
    sidebarAdmin,
    tableAdminProd,
  },
};
</script>


// WEBPACK FOOTER //
// Admin-products.vue?ca13fef4